import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Logodark, Logolight } from './assets';
// import MobileThemeToggle from './MobileThemeToggle';
import NavMenuMobile from './NavMenuMobile';
import { navData } from './navData';
import './nav.css';
import type { RootState } from '../../Redux/Store';
import { logAnalyticsEvent } from '../../GoogeAnalytics';

const MobileNav = () => {
  const dark = useSelector((state: RootState) => state.themeSlice.dark);
  const { isTablet } = useSelector((state: RootState) => state.tabletSlice);
  const [menuOpen, setMenuOpen] = useState<'block' | 'none'>('none');
  const navigate = useNavigate();

  const handleNavClick = (link: string, itemName?: string, buttonType: 'navigation' | 'cta' = 'navigation') => {
    setMenuOpen('none');

    if (itemName) {
      logAnalyticsEvent('button_click', {
        button_name: `mobile_nav_${itemName.toLowerCase().replace(/\s+/g, '_')}`,
        button_type: buttonType,
        page_path: window.location.pathname,
      });
    }

    if (link.startsWith('/#')) {
      const hash = link.slice(1);
      if (window.location.pathname !== '/') {
        navigate('/');
        setTimeout(() => {
          document.querySelector(hash)?.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      } else {
        document.querySelector(hash)?.scrollIntoView({ behavior: 'smooth' });
      }
      return;
    }
    navigate(link);
  };

  return (
    <div
      className={`topnav ${dark ? 'mobilenavDark' : 'mobilenavLight'}`}
      id="top-navbar"
    >
      <div
        className="Logo-container active"
        style={{
          backgroundColor: dark ? 'black' : 'white',
          color: dark ? 'white' : 'black',
        }}
      >
        <Link
          to="/"
          onClick={() => {
            setMenuOpen('none');
            logAnalyticsEvent('button_click', {
              button_name: 'mobile_nav_logo',
              button_type: 'navigation',
              page_path: window.location.pathname,
            });
          }}
          style={{ display: 'block', height: '100%' }}
        >
          <img
            src={dark ? Logolight : Logodark}
            alt="VisCommerce"
            width={243}
            height={60}
          />
        </Link>
      </div>

      <div
        className="myLinks"
        style={{ display: menuOpen }}
      >
        {navData.map((item) =>
          item.dropdown ? (
            <div key={item.id}>
              <p className="mobile-nav-group">{item.name}</p>
              {item.children.map((child) => (
                <p
                  key={child.link}
                  className="mobile-nav-subitem"
                >
                  <Link
                    to={child.link}
                    onClick={() => handleNavClick(child.link, child.name)}
                    style={{ textDecoration: 'none', color: 'inherit', display: 'block', width: '100%' }}
                  >
                    {child.name}
                  </Link>
                </p>
              ))}
            </div>
          ) : (
            <p key={item.id}>
              <Link
                to={item.link}
                onClick={() => handleNavClick(item.link, item.name)}
                style={{ textDecoration: 'none', color: 'inherit', display: 'block', width: '100%' }}
              >
                {item.name}
              </Link>
            </p>
          )
        )}

        <div
          className="extra-btns"
          style={{ flexDirection: 'column' }}
        >
          <Link
            to="/book-demo"
            id="contact"
            className={`mobileNavBtns ${dark ? 'contact-btn-dark' : 'contact-btn-white'}`}
            onClick={() => handleNavClick('/book-demo', 'book_demo', 'cta')}
            style={{ textDecoration: 'none', display: 'block' }}
          >
            Book a 45-min briefing
          </Link>
        </div>

        {/* <div style={{ padding: '5px', display: 'flex', justifyContent: 'center' }}>
          <MobileThemeToggle />
        </div> */}
      </div>

      <p
        className="icon Hamburger"
        style={{
          paddingTop: '25px',
          paddingRight: isTablet ? '30px' : '',
          backgroundColor: dark ? 'black' : 'white',
          color: dark ? 'white' : 'black',
        }}
        onClick={() => {
          const nextState = menuOpen === 'block' ? 'none' : 'block';
          setMenuOpen(nextState);
          logAnalyticsEvent('button_click', {
            button_name: `mobile_hamburger_${nextState === 'block' ? 'open' : 'close'}`,
            button_type: 'utility',
            page_path: window.location.pathname,
          });
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            const nextState = menuOpen === 'block' ? 'none' : 'block';
            setMenuOpen(nextState);
            logAnalyticsEvent('button_click', {
              button_name: `mobile_hamburger_${nextState === 'block' ? 'open' : 'close'}`,
              button_type: 'utility',
              page_path: window.location.pathname,
            });
          }
        }}
        role="button"
        tabIndex={0}
        aria-label="Toggle menu"
        aria-expanded={menuOpen === 'block'}
      >
        <NavMenuMobile />
      </p>
    </div>
  );
};

export default MobileNav;
